import { AfterViewInit, Directive, ElementRef, EventEmitter, OnDestroy, Output, Renderer2 } from '@angular/core';

@Directive({
    selector: '[clickOutside]',
    standalone: true,
})
export class ClickOutsideDirective implements AfterViewInit, OnDestroy {
    @Output() clickOutside = new EventEmitter();

    private listener?: Function;

    constructor(
        private renderer: Renderer2,
        private element: ElementRef,
    ) {}

    ngAfterViewInit() {
        this.listener = this.renderer.listen(document, 'click', (event) => {
            if (!this.element.nativeElement.contains(event.target)) {
                this.clickOutside.emit(event);
            }
        });
    }

    ngOnDestroy() {
        if (this.listener) {
            this.listener();
        }
    }
}
